import { createSlice } from '@reduxjs/toolkit';
import { getAllCustomerRequests, editCustomerRequest, getCustomerRequestById } from './customerRequestsService';

const initialState = {
  allCustomerRequests: {
    isCustomerRequestsLoading: null,
    isCustomerRequestsSuccess: null,
    customerRequestRequestsMessage: null,
    pageCount: 0,
    customerRequests: [],
  },
  customerRequest: {
    isCustomerRequestLoading: null,
    isCustomerRequestLoaded: null,
    request: null,
  },

  editedCustomerRequest: {
    isEditingCustomerRequest: null,
    isCustomerRequestEdited: null,
    customerRequestEditedMsg: null
  }
};

const customerRequestSlice = createSlice({
  name: 'customerRequest',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCustomerRequests.pending, (state) => {
        state.allCustomerRequests = {
          ...initialState.allCustomerRequests, // Reset to initial state
          isCustomerRequestsLoading: true,
          customerRequestsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCustomerRequests.rejected, (state, action) => {
        state.allCustomerRequests = {
          ...initialState.allCustomerRequests,
          isCustomerRequestsLoading: false,
          isCustomerRequestsSuccess: false,
          customerRequestsMessage: action.payload || 'Error occurred while fetching customerRequestRequests',
        };
      })

      // FULFILLED
      .addCase(getAllCustomerRequests.fulfilled, (state, action) => {
        state.allCustomerRequests = {
          ...initialState.allCustomerRequests,
          isCustomerRequestsLoading: false,
          isCustomerRequestsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          customerRequests: action.payload.data || [],
        };
      });

    //Customer request by Id
    builder
      .addCase(getCustomerRequestById.pending, (state) => {
        state.customerRequest = {
          ...initialState.customerRequest,
          isCustomerRequestLoading: true,
        };
      })
      .addCase(getCustomerRequestById.rejected, (state) => {
        state.customerRequest = {
          ...initialState.customerRequest,
          isCustomerRequestLoading: false,
          isCustomerRequestLoaded: false,
        };
      })
      .addCase(getCustomerRequestById.fulfilled, (state, action) => {
        state.customerRequest = {
          ...initialState.customerRequest,
          isCustomerRequestLoading: false,
          isCustomerRequestLoaded: true,
          request: action.payload,
        };
      });

    //Customer editing
    builder
      .addCase(editCustomerRequest.pending, (state) => {
        state.editedCustomerRequest = {
          ...initialState.editedCustomerRequest, // Reset to initial state
          isEditingCustomerRequest: true,
          customerRequestEditedMsg: 'Loading',
        };
      })

      .addCase(editCustomerRequest.rejected, (state, action) => {
        state.editedCustomerRequest = {
          ...initialState.editedCustomerRequest,
          isEditingCustomerRequest: false,
          isCustomerRequestEdited: false,
          customerRequestEditedMsg: action.payload || 'Error occurred while editing the customerRequest.',
        };
      })

      .addCase(editCustomerRequest.fulfilled, (state, action) => {
        state.editedCustomerRequest = {
          ...initialState.editedCustomerRequest, 
          isEditingCustomerRequest: false,
          isCustomerRequestEdited: true,
          customerRequestEditedMsg: action.payload || 'Successfully edited the customerRequest.',
        };
      });
  },
});

export default customerRequestSlice.reducer;
